import type { FC } from 'react';

import { Message } from '#packages/web/foundations/feedback/message/message';

import { MessagePage, type MessagePageProps } from './message-page';

export type NotFoundPageProps = MessagePageProps;

export const NotFoundPage: FC<NotFoundPageProps> = ({
  image = (
    <img
      src="https://placehold.co/200x100/dddddd/999999"
      alt="Not Found."
      style={{ display: 'flex' }}
    />
  ),
  message = <Message>Not Found.</Message>,

  ...props
}) => <MessagePage image={image} message={message} {...props} />;
